import { NgModule } from '@angular/core';
import { PopupService } from '@local/ui-infra';
import { GoLinksViewModule } from '../results-views/go-links/go-links-view.module';

//collections
import { CollectionGhostComponent } from './components/collection-ghost/collection-ghost.component';
import { CollectionItemComponent } from './components/collection-item/collection-item.component';
import { CollectionTagSectionComponent } from './components/collection-tag-section/collection-tag-section.component';
import { CollectionViewComponent } from './components/collection-view/collection-view.component';
import { CollectionsContainerComponent } from './components/collections-container/collections-container.component';
import { CollectionsEmptyStateComponent } from './components/collections-empty-state/collections-empty-state.component';
import { CollectionSaveComponent } from './components/collections-save/collection-save.component';
import { LiveCollectionComponent } from './components/live-collection/live-collection.component';
import { NewStaticItemPopupComponent } from './components/new-static-item-popup/new-static-item-popup.component';
import { SearchExpandableButtonComponent } from './components/search-expandable-button/search-expandable-button.component';
import { SearchResultsListComponent } from './components/search-results-list/search-results-list.component';
import { SortingFilterPopupComponent } from './components/sorting-filter-popup/sorting-filter-popup.component';
import { StaticCollectionComponent } from './components/static-collection/static-collection.component';
import { CollectionPopupService } from './services/collection-popup.service';
import { CollectionHeaderLineComponent } from './components/collection-header-line/collection-header-line.component';
import { BlobPreviewService } from './services/blobs-preview.service';

//wiki
import { WikiCardFooterComponent } from './components/wiki-card-footer/wiki-card-footer.component';
import { WikiCardHeaderLineComponent } from './components/wiki-card-header-line/wiki-card-header-line.component';
import { WikiCardPopupComponent } from './components/wiki-card-popup/wiki-card-popup.component';
import { WikiCollectionComponent } from './components/wiki-collection/wiki-collection.component';
import { WikiEmptyStateComponent } from './components/wiki-empty-state/wiki-empty-state.component';
import { WikiCardPreviewService } from './services/wiki-card-preview.service';
import { RequestsHistoryLineComponent } from './components/requests-history-line/requests-history-line.component';
import { VerificationsCardsCommandsService } from './services/verifications-cards-commands-service';
import { WikiCardHeaderActionsComponent } from './components/wiki-card-header-actions/wiki-card-header-actions.component';
import { WikiPopupsService } from './services/wiki-popups.service';
import { WikiTreeComponent } from './components/wiki-tree/wiki-tree.component';
import { WikiItemMoveToPopupComponent } from './components/wiki-item-move-to-popup/wiki-item-move-to-popup.component';
import { WikiItemSelectionPopupService } from './services/wiki-item-selection-popup.service';
import { WikiCardSaveFlowService } from './services/wiki-card-save-flow.service';
import { WikiCardDraftSubHeaderComponent } from './components/wiki-card-draft-sub-header/wiki-card-draft-sub-header.component';
import { WikiCardSubHeaderComponent } from './components/wiki-card-sub-header/wiki-card-sub-header.component';
import { WikiCardDraftFooterComponent } from './components/wiki-card-draft-footer/wiki-card-draft-footer.component';
import { WikiCardVersionsPopupComponent } from './components/wiki-card-versions-popup/wiki-card-versions-popup/wiki-card-versions-popup.component';
import { WikiCardCompareVersionComponent } from './components/wiki-card-versions-popup/wiki-card-compare-version/wiki-card-compare-version.component';
import { WikiCardVersionListComponent } from './components/wiki-card-versions-popup/wiki-card-version-list/wiki-card-version-list.component';
import { FrameEditorModule } from '../frame-editor/frame-editor.module';

const components = [
  CollectionItemComponent,
  CollectionGhostComponent,
  CollectionsContainerComponent,
  CollectionSaveComponent,
  CollectionsEmptyStateComponent,
  CollectionTagSectionComponent,
  CollectionViewComponent,
  LiveCollectionComponent,
  NewStaticItemPopupComponent,
  SearchExpandableButtonComponent,
  SearchResultsListComponent,
  SortingFilterPopupComponent,
  StaticCollectionComponent,
  WikiCardFooterComponent,
  WikiCardDraftFooterComponent,
  WikiCardHeaderLineComponent,
  WikiCardDraftSubHeaderComponent,
  WikiCardSubHeaderComponent,
  WikiCardPopupComponent,
  WikiCollectionComponent,
  WikiEmptyStateComponent,
  RequestsHistoryLineComponent,
  CollectionHeaderLineComponent,
  WikiCardHeaderActionsComponent,
  WikiTreeComponent,
  WikiItemMoveToPopupComponent,
  WikiCardVersionsPopupComponent,
  WikiCardVersionListComponent,
  WikiCardCompareVersionComponent,
];

const modules = [GoLinksViewModule, FrameEditorModule];

@NgModule({
  declarations: components,
  imports: modules,
  providers: [
    { provide: PopupService, useClass: PopupService },
    CollectionPopupService,
    BlobPreviewService,
    WikiCardPreviewService,
    VerificationsCardsCommandsService,
    WikiPopupsService,
    WikiItemSelectionPopupService,
    WikiCardSaveFlowService,
  ],
  exports: [...modules, ...components],
})
export class CollectionsPageModule {}
